import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonItem, IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-form-item',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel],
  templateUrl: './form-item.component.html',
  styleUrl: './form-item.component.css',
})
export class FormItemComponent {
  @Input() formName!: string;
  @Input() description?: string;
  @Input() button = false;
  @Input() detail = false;
  @Input() lines?: string;
  @Output() click = new EventEmitter<void>();

  onItemClick(): void {
    this.click.emit();
  }
}
